import type { WorkHoursInterval } from '@elfsight/widget-business-hours';
import {
  addMinutes,
  areIntervalsOverlapping,
  eachMinuteOfInterval,
  isBefore
} from 'date-fns';

export function createTimeslots(
  hours: WorkHoursInterval[],
  step = 30,
  minAdvance = 30,
  reservedIntervals: Interval[] = [],
  lockedIntervals: Interval[] = []
) {
  return hours.flatMap(([start, end]) => {
    const interval =
      start.getTime() !== end.getTime()
        ? eachMinuteOfInterval({ start, end }, { step }).slice(0, -1)
        : [];

    return interval.map((_start) => {
      const _end = addMinutes(_start, step);
      const start = _start;
      const end = _end;

      const reserved = reservedIntervals.some((interval) => {
        return areIntervalsOverlapping(interval, { start, end });
      });
      const locked = lockedIntervals.some((interval) => {
        return areIntervalsOverlapping(interval, { start, end });
      });
      const past = isBefore(start, addMinutes(new Date(), minAdvance));

      return {
        from: start,
        to: end,
        reserved,
        locked,
        past
      };
    });
  });
}
